import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  SimpleGrid,
  Button,
  Image,
  Text,
  Stack,
  Flex,
  Divider,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { FaEdit, FaRupeeSign, FaTrash } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import RoomUpdateModal from "./updateRoomModal";
import Cookie from "js-cookie";

const RoomData = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = useState([]);
  const [room, setRoom] = useState({});
  const [id, setId] = useState("");
  const [isOpen1, setIsOpen] = useState(false);
  const customerId = localStorage.getItem("customerId");
  const [filter, setFilter] = useState({ category: "", ac: "" });
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();

  // Fetch room data
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomdata/${customerId}`,
      );
      const rooms = response.data.room;

      // const updatedRooms = await Promise.all(
      //   rooms.map(async (room) => {
      //     if (room.image) {
      //       try {
      //         const imageResponse = await axios.get(`https://api.hotel.launchlysoftware.in/get-image/${room.image}`, { responseType: 'blob' });
      //         room.imageUrl = URL.createObjectURL(imageResponse.data);
      //       } catch (error) {
      //         console.error(`Error fetching image for room: ${room.image}`, error);
      //         room.imageUrl = null;
      //       }
      //     } else {
      //       room.imageUrl = null;
      //     }
      //     return room;
      //   })
      // );

      setData(rooms);
    } catch (error) {
      console.error("Error fetching room data:", error);
      toast.error("Failed to load room data.");
    }
  };
  console.log(data, "data");
  const DeleteModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  const handleRoomAvailability = async (id) => {
    try {
      const response = await axios.put(
        `https://api.hotel.launchlysoftware.in/api/updateAvailability/${customerId}/${id}`,
      );
      toast.success(response.data.message);
      window.location.reload();
    } catch (error) {
      console.error("Error updating room availability:", error);
      toast.error("Failed to update room availability.");
    }
  };
  const token = Cookie.get("token");

  const handleDelete = async () => {
    try {
      await axios.delete(
        `https://api.hotel.launchlysoftware.in/api/roomDelete/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success("Room deleted successfully.");
      setIsOpen(false);

      fetchData();
    } catch (error) {
      console.error("Error deleting room:", error);
      toast.error(error.response.data.message);
    }
  };

  const updateFood = async (id) => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomData/${customerId}/${id}`,
      );
      setRoom(response.data.room);
      setId(id);
      onOpen();
    } catch (error) {
      console.error("Error fetching room data for update:", error);
      toast.error("Failed to fetch room data.");
    }
  };

  const handleFilterChange = (key, value) => {
    setFilter((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    fetchData();
  }, [customerId]);

  const filteredData = data?.filter(
    (item) =>
      (filter.category === "" || item.category === filter.category) &&
      (filter.ac === "" || item.ac === filter.ac),
  );

  return (
    <Box p={10}>
      <SimpleGrid columns={4} spacing={4} mb={4}>
        <Button
          colorScheme={filter.category === "" ? "blue" : "gray"}
          onClick={() => handleFilterChange("category", "")}
        >
          All Categories
        </Button>
        {[...new Set(data.map((item) => item.category))].map((category) => (
          <Button
            key={category}
            colorScheme={filter.category === category ? "blue" : "gray"}
            onClick={() => handleFilterChange("category", category)}
          >
            {category}
          </Button>
        ))}
      </SimpleGrid>
      <SimpleGrid columns={3} spacing={4} mb={4}>
        <Button
          colorScheme={filter.ac === "" ? "green" : "gray"}
          onClick={() => handleFilterChange("ac", "")}
        >
          All AC/Non-AC
        </Button>
        <Button
          colorScheme={filter.ac === "AC" ? "green" : "gray"}
          onClick={() => handleFilterChange("ac", "AC")}
        >
          AC
        </Button>
        <Button
          colorScheme={filter.ac === "Non-AC" ? "green" : "gray"}
          onClick={() => handleFilterChange("ac", "Non-AC")}
        >
          Non-AC
        </Button>
      </SimpleGrid>

      <RoomUpdateModal
        isOpen={isOpen}
        onClose={onClose}
        data={room}
        customerId={customerId}
        id={id}
        setSelectId={setId}
      />

      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <SimpleGrid minChildWidth="280px" spacing={6}>
        {filteredData.map((item, index) => (
          <Card key={index} boxShadow="lg">
            <CardBody>
              <Image
                src={item.imageUrl}
                alt={item.roomNo}
                borderRadius="lg"
                height="230px"
                width="full"
              />
              <Stack mt="6" spacing="3">
                <Text as="b" color="blue.500">
                  Room No: {item.roomNo}
                </Text>
                <Flex justifyContent="space-between">
                  <Text>Category: {item.category}</Text>
                  <Text>Type: {item.ac}</Text>
                </Flex>
                <Flex justifyContent="space-between">
                  <Text
                    fontSize="2xl"
                    alignItems="center"
                    display="flex"
                    color="blue.600"
                  >
                    <FaRupeeSign /> {item.rate}
                  </Text>
                  <Flex gap={2}>
                    <Button
                      variant="ghost"
                      colorScheme="green"
                      onClick={() => updateFood(item._id)}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="ghost"
                      colorScheme="red"
                      onClick={() => DeleteModal(item._id)}
                    >
                      <FaTrash />
                    </Button>
                  </Flex>
                </Flex>
              </Stack>
            </CardBody>
            <Divider />
            <CardFooter>
              <ButtonGroup spacing={2}>
                <Button
                  colorScheme="blue"
                  onClick={() => handleRoomAvailability(item._id)}
                  isDisabled={item.availability}
                >
                  Change Status
                </Button>
                <Button
                  variant="outline"
                  colorScheme={item.availability ? "green" : "red"}
                >
                  {item.availability ? "Not Booked" : "Booked"}
                </Button>
              </ButtonGroup>
            </CardFooter>
          </Card>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default RoomData;
